import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';
import { useTranslation } from 'react-i18next';

function Footer2(props) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <footer className="footer style-2 mt-3 py-3">
                         <div className="footer-inner">
                             <div className="tf-container">
                                 <div className="row">
                                     <div className="col-md-12">
                                         <h2 className="title">{t('JOIN OUR COMMUNITY')}</h2>
                                         <div className="group-btn mt-5">
                                             <Link to="/collection" className="tf-button">{t('buy_fc_coins')}</Link>
                                         </div>
                                         <ul className="social-item">
                                             <li>
                                                 <a href="https://www.instagram.com/masterfut_store?igsh=MW9mODZvb2sxcmd1" target="_blank" rel="noopener noreferrer">
                                                     <i className="fab fa-instagram"></i>
                                                 </a>
                                             </li>
                                         </ul>
                                     </div>
                                 </div>
                             </div>
                         </div>
             
                         <div className="bottom-inner">
                             <div className="tf-container">
                                 <div className="row">
                                     <div className="col-md-12">
                                         <div className="text-center bottom d-flex justify-content-between align-items-start mt-3 ">
                                             {/* Left Side - Copyright */}
                                             <div className="content-left d-flex align-items-center justify-content-center text-center" style={{ flex: '1', maxWidth: '600px' ,     marginTop: '60px'}}>
                                                 <img src="https://www.masterfut.com/images/logos/logo.png" alt="masterfut" style={{ width: "60px" }} />
                                                 <p 
                                                     className="copy-right" 
                                                     style={{ 
                                                         textAlign: 'left',
                                                         marginTop: '10px',
                                                         lineHeight: '1.5'
                                                     }}
                                                     dangerouslySetInnerHTML={{ __html: t('COPYRIGHT') }} 
                                                 />
                                             </div>
             
                                             {/* Right Side - Links */}
                                             <div className="content-right d-flex flex-wrap gap-4">
                                                 {/* Masterfut Links */}
                                                 <div className="seo-links" style={{ 
                                                     display: 'flex', 
                                                     flexDirection: 'column', 
                                                     minWidth: '150px'
                                                 }}>
                                                     <span style={{ 
                                                         fontWeight: 'bold', 
                                                         color: 'white', 
                                                         marginBottom: '10px',
                                                         textAlign: 'left'
                                                     }}>
                                                         {t('Masterfut')}
                                                     </span>
                                                     <Link to="/buy-fc-coins" style={{ fontSize: "14px", color: "white", textAlign: 'left', marginBottom: '5px' }}>
                                                         {t('Buy FC Coins')}
                                                     </Link>
                                                     <Link to="/cheap-fc-coins" style={{ fontSize: "14px", color: "white", textAlign: 'left', marginBottom: '5px' }}>
                                                         {t('Cheap FC Coins')}
                                                     </Link>
                                                     <Link to="/fast-fc-coins-delivery" style={{ fontSize: "14px", color: "white", textAlign: 'left', marginBottom: '5px' }}>
                                                         {t('Fast FC Coins Delivery')}
                                                     </Link>
                                                     <Link to="/best-place-to-buy-fc-coins" style={{ fontSize: "14px", color: "white", textAlign: 'left', marginBottom: '5px' }}>
                                                         {t('Best Place to Buy FC Coins')}
                                                     </Link>
                                                     <Link to="/sell-fc-coins-safely" style={{ fontSize: "14px", color: "white", textAlign: 'left' }}>
                                                         {t('Sell FC Coins Safely')}
                                                     </Link>
                                                 </div>
                                                 
                                                 {/* Legal Links */}
                                                 <div className="legal-links" style={{ 
                                                     display: 'flex', 
                                                     flexDirection: 'column', 
                                                     minWidth: '150px'
                                                 }}>
                                                     <span style={{ 
                                                         fontWeight: 'bold', 
                                                         color: 'white', 
                                                         marginBottom: '10px',
                                                         textAlign: 'left'
                                                     }}>
                                                         {t('Legal')}
                                                     </span>
                                                     <Link to="/terms" style={{ fontSize: "14px", color: "white", marginBottom: '5px', textAlign: 'left' }}>
                                                         {t('Terms of Service')}
                                                     </Link>
                                                     <Link to="/privacy" style={{ fontSize: "14px", color: "white", marginBottom: '5px', textAlign: 'left' }}>
                                                         {t('Privacy Notice')}
                                                     </Link>
                                                     <Link to="/refund-promise" style={{ fontSize: "14px", color: "white", textAlign: 'left' }}>
                                                         {t('Refund Policy')}
                                                     </Link>
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
             
                         {isVisible &&
                             <Link onClick={scrollToTop} to='#' id="scroll-top"></Link>
                         }
                     </footer>
    );
}

export default Footer2;
